import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecipesSearchModule } from '../recipes-search/recipes-search.module';
import {
  RecipeService,
  TarifService,
  ProductService,
  IntroService
} from '../shared/services';
import { routing } from './header-mobile.routing';

import { HeaderMobileComponent } from './header-mobile.component';
import {CookbookFilterModule} from '../cookbook-filter/cookbook-filter.module';
import {CategoryFilterModule} from '../category-filter/category-filter.module';
import { GroupFilterModule } from '../group-filter/group-filter.module';
import { RecipesSortingsModule } from '../recipes-sortings/recipes-sortings.module';
import { IngredientFilterModule } from '../ingredient-filter/ingredient-filter.module';
import {DatepickerModule} from '@app/datepicker/datepicker.module';
import { DialogModule } from 'primeng/components/dialog/dialog';

@NgModule({
  imports: [
    routing,
    CommonModule,
    RecipesSearchModule,
    CookbookFilterModule,
    CategoryFilterModule,
    GroupFilterModule,
    RecipesSortingsModule,
    IngredientFilterModule,
    DatepickerModule,
    DialogModule
  ],
  declarations: [
    HeaderMobileComponent
  ],
  providers: [
    TarifService,
    RecipeService,
    ProductService,
    IntroService
  ],
  exports: [
    HeaderMobileComponent
  ]
})
export class HeaderMobileModule { }



// WEBPACK FOOTER //
// ./src/app/header-mobile/header-mobile.module.ts